module.exports = __webpack_public_path__ + "static/media/info.dd8522af.svg";